import React from 'react';
import { Table } from 'antd';

const BaseTaxTable = ({ zoopPlan, mode }) => {
  const getPaymentTypes = () => {
    if (mode === 'physical' || mode === 'online') {
      return ['debit', 'credit'];
    }
    return ['debit'];
  };

  const getFees = () => {
    let fees = zoopPlan?.details?.fees || {};
    let filteredFees = {};
    for (let paymentType in fees) {
      if (mode !== 'others' && paymentType !== 'credit' && paymentType !== 'debit') {
        continue;
      }
      let paymentFees = {};
      for (let installment in fees[paymentType]) {
        let installmentFees = {};
        for (let brand in fees[paymentType][installment]) {
          let brandFees = [];
          for (let fee of fees[paymentType][installment][brand]) {
            if (fee['capture_mode'] == null && mode === 'online') {
              continue;
            }
            if (fee['capture_mode'] === 'manually_keyed' && mode === 'physical') {
              continue;
            }
            brandFees.push(fee);
          }
          if (brandFees.length > 0) {
            installmentFees[brand] = brandFees;
          }
        }
        if (Object.keys(installmentFees).length > 0) {
          paymentFees[installment] = installmentFees;
        }
      }
      if (Object.keys(paymentFees).length > 0) {
        filteredFees[paymentType] = paymentFees;
      }
    }
    return filteredFees;
  };

  const getBrands = () => {
    const fees = getFees();

    if (mode === 'others') {
      const brands = [];
      if (fees['pix']) brands.push('PIX');
      if (fees['boleto']) brands.push('Boleto');
      return brands;
    }

    let brands = [];
    for (let paymentType in fees) {
      for (let installment in fees[paymentType]) {
        for (let brand in fees[paymentType][installment]) {
          if (!brands.includes(brand)) {
            brands.push(brand);
          }
        }
      }
    }
    if (brands.includes('Elo')) {
      brands = ['Elo', ...brands.filter(b => b !== 'Elo')];
    }
    if (brands.includes('Visa')) {
      brands = ['Visa', ...brands.filter(b => b !== 'Visa')];
    }
    if (brands.includes('MasterCard')) {
      brands = ['MasterCard', ...brands.filter(b => b !== 'MasterCard')];
    }
    return brands;
  };

  const sortNumerically = (keys) => [...keys].sort((a, b) => Number(a) - Number(b));

  const getInstallments = (paymentType) => {
    const fees = getFees();
    if (mode === 'others') {
      const keys = new Set([
        ...Object.keys(fees['pix'] || {}),
        ...Object.keys(fees['boleto'] || {}),
      ]);
      return keys.size > 0 ? sortNumerically(keys) : [];
    }
    return sortNumerically(Object.keys(fees[paymentType] || {}));
  };

  const getBaseTax = (paymentType, installment, brand) => {
    if (brand === 'PIX') {
      paymentType = 'pix';
      brand = null;
    } else if (brand === 'Boleto') {
      paymentType = 'boleto';
      brand = null;
    }

    const fees = getFees();
    if (!fees[paymentType] || !fees[paymentType][installment] || !fees[paymentType][installment][brand]) {
      return '-';
    }

    const fee = fees[paymentType][installment][brand][0];
    if (fee.dollar_amount > 0) {
      return `R$ ${(fee.dollar_amount / 100).toFixed(2)}`;
    }
    return `${(fee.percent_amount / 100).toFixed(2)}%`;
  };

  const brands = getBrands();

  const columns = [
    { title: 'Tipo', dataIndex: 'type', key: 'type', fixed: 'left' },
    { title: 'Parcelas', dataIndex: 'installments', key: 'installments', fixed: 'left' },
    ...brands.map(brand => ({
      title: brand,
      dataIndex: brand,
      key: brand,
    })),
  ];

  const dataSource = [];
  getPaymentTypes().forEach((paymentType) => {
    const paymentTypeName = paymentType === 'credit' ? 'Crédito' : 'Débito';
    getInstallments(paymentType).forEach((installment, index) => {
      dataSource.push({
        key: `${paymentType}-${installment}`,
        type: index === 0 ? paymentTypeName : '',
        installments: `${installment}x`,
        ...brands.reduce((acc, brand) => {
          acc[brand] = getBaseTax(paymentType, installment, brand);
          return acc;
        }, {}),
      });
    });
  });

  const emptyMessage = () => {
    if (mode === 'others') {
      return 'Este plano não possui taxas de Boleto ou Pix.';
    }
    return `Este plano não possui suporte a vendas débito/crédito para ${mode === 'online' ? 'Online' : 'Presencial'}`;
  };

  if (brands.length === 0 || dataSource.length === 0) {
    return <p>{emptyMessage()}</p>;
  }

  return (
    <Table
      className='baseTaxTable'
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      scroll={{ x: 'max-content' }}
      bordered
      sticky
    />
  );
};

export default BaseTaxTable;
